<template>
	<div class="CommodityAdd">
		<div class="type">选择商品分类</div>
		<div class="step_bar">
			<el-steps :active="stepActive" finish-status="success" align-center>
				<el-step title="填写影像商品信息"></el-step>
				<el-step title="填写影像商品参数"></el-step>
				<el-step title="填写交付信息"></el-step>
			</el-steps>
			<div v-show="stepActive === 0 && this.editID == ''"><el-button type="primary" plain size="medium" @click="toBulkImport"> 批量导入</el-button></div>
		</div>

		<div class="formBox">
			<el-form ref="form" :model="Myform" label-width="110px" :label-position="'left'" :rules="rules">
				<!-- 步骤一  商品信息 -->
				<div v-show="stepActive === 0" class="step0">
					<!-- <el-form-item label="商品类型" class="form_item">
					<div class="isFlex">
						<el-select v-model="Myform.goodsInfo.goodsCategory" disabled placeholder="请选择商品类型" size="small"
							auto-complete="" style="width: 250px">
							<el-option label="影像数据" :value="1"></el-option>
							<el-option label="数据产品" :value="2"></el-option>
							<el-option label="软件产品" :value="3"></el-option>
						</el-select>
					</div>
				</el-form-item> -->

					<el-form-item label="卫星分类" class="form_item" prop="satellite_classification" style="margin-bottom: 12px">
						<el-cascader style="width: 250px" size="small" :props="satelliteprops" v-model="satellite_classification" :options="satelliteOptions"></el-cascader>
					</el-form-item>
					<!-- <el-form-item label="数据类别" class="form_item">
		<el-radio-group v-model="data_category">
			<el-radio label="基础数据"></el-radio>
			<el-radio label="产品数据"></el-radio>
		</el-radio-group>
		</el-form-item> -->
					<transition name="el-fade-in-linear" v-if="showProductData">
						<el-form-item label="应用领域分类" class="form_item">
							<div style="display: flex; margin-bottom: 5px; flex-wrap: wrap">
								<div
									class="btn"
									v-for="(button, i) in applicationList"
									:key="i"
									size="mini"
									style="margin: 4px 3px"
									:class="{ isclick: selectbuttons == button.id }"
									@click="selectapplication(button.id)"
								>
									{{ button.plateName }}
								</div>
							</div>
						</el-form-item>
					</transition>
					<el-form-item label="商品名称" prop="goodsInfo.goodsName" class="form_item" style="margin-bottom: 12px">
						<el-input v-model="Myform.goodsInfo.goodsName" size="small" placeholder="商品名称不可重复，要求与服务紧密相关，2～30个字"></el-input>
					</el-form-item>
					<el-form-item label="商品价格" class="form_item">
						<div class="isFlex">
							<el-select v-model="Myform.goodsInfo.goodsPriceType" placeholder="请选择活动区域" size="small" style="width: 250px">
								<el-option label="免费" :value="3"></el-option>
								<el-option label="面议" :value="2"></el-option>
								<el-option label="商品金额" :value="1"></el-option>
							</el-select>
							<el-input
								@input="GreaterZero()"
								v-show="Myform.goodsInfo.goodsPriceType === 1"
								size="small"
								v-model.number="Myform.goodsInfo.goodsPrice"
								style="margin-left: 8px; width: 200px"
								placeholder="填写价格"
							></el-input>
						</div>
					</el-form-item>
					<!-- <el-form-item label="所属区域" class="form_item">
					<citySingle :sendCityInfo="acceptCityInfo" @getCityInfo="getCityInfoFun" style="width: 100%">
					</citySingle>
				</el-form-item> -->
					<el-form-item label="商品描述">
						<el-input type="textarea" v-model="Myform.goodsInfo.goodsDescribe" :rows="4" maxlength="100" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="商品图片">
						<div class="imgList">
							<el-upload class="avatar-uploader" :action="this.$const.common.fileUpload" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
								<img v-if="Myform.goodsInfo.goodsThumbnail" :src="Myform.goodsInfo.goodsThumbnail" class="avatar" />
								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
								<div slot="tip" class="el-upload__tip">商品图片大小不超过5M</div>
							</el-upload>
						</div>
					</el-form-item>
					<el-form-item label="说明文档">
						<div>
							<el-upload
								:auto-upload="false"
								class="upload-demo"
								action="#"
								accept=".docx, .pdf"
								:on-preview="handlePreview"
								:on-remove="handleRemove"
								:before-remove="beforeRemove"
								:on-change="uploadFile"
								multiple
								:limit="1"
								:on-exceed="handleExceed"
								:file-list="fileList"
							>
								<el-button type="primary" size="small">上传附件</el-button>
								<div slot="tip" class="el-upload__tip">只能上传docx/pdf文件，上传文件大小不能超过 20MB!</div>
							</el-upload>
						</div>
					</el-form-item>
				</div>
				<!-- 步骤二   商品参数数据信息 -->
				<div v-show="stepActive === 1" class="step1">
					<div class="tableBox" v-for="(item, y) in data_parameter" :key="y">
						<div class="table_title">{{ item.name }}</div>
						<div class="table_infoBox">
							<div class="table_infoItem" v-for="(t, index) in item.list" :key="index">
								<div class="table_infoItemLeft">{{ t.name }}</div>
								<el-date-picker
									v-if="t.type == 'datetime'"
									value-format="yyyy-MM-dd HH:mm:ss"
									v-model="Myform[item.type][t.label]"
									type="datetime"
									placeholder="选择日期"
									class="table_datetimeRight"
								>
								</el-date-picker>
								<el-select v-else-if="t.type == 'select'" v-model="Myform[item.type][t.label]" placeholder="请选择" size="small" class="table_datetimeRight">
									<el-option v-for="(item, i) in t.dataList" :key="i" :label="item.label" :value="item.label"></el-option>
								</el-select>
								<input :type="t.type == 'number' ? 'number' : 'text'" v-else v-model="Myform[item.type][t.label]" class="table_infoItemRight" />
							</div>
						</div>
					</div>
				</div>

				<!-- 商品交付信息 -->
				<div v-show="stepActive === 2" class="step2">
					<el-form-item label="计费方式">
						<el-radio-group v-model="Myform.goodsInfo.chargingType">
							<el-radio :label="1">按次计费</el-radio>
							<el-radio :label="2">按周期计费</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="交付方式">
						<el-radio-group v-model="Myform.goodsInfo.deliveryType">
							<!-- <el-radio :label="1">线上交易</el-radio> -->
							<el-radio :label="2">线下预约交易</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="截止日期">
						<el-date-picker :disabled="long_term_effective" v-model="goodsInfo_endDate" type="date" placeholder="选择日期"> </el-date-picker>
						<el-checkbox v-model="long_term_effective" style="margin-left: 20px">长期有效</el-checkbox>
					</el-form-item>
					<el-form-item label="交付时间">
						<el-radio-group v-model="deliveryDate">
							<el-radio label="实时">实时</el-radio>
							<el-radio label="天"></el-radio>
						</el-radio-group>
						<el-input v-if="deliveryDate === '天'" style="width: 80px; margin-left: 18px" size="small" v-model.number="day"></el-input>
					</el-form-item>
					<!-- <el-form-item label="数据下载地址">
					<el-input placeholder="请输入内容" v-model="Myform.goodsInfo.dataDownloadUrl"></el-input>
				</el-form-item> -->
				</div>
			</el-form>
		</div>
		<!-- 提交按钮 -->
		<div class="buttonBox">
			<el-button v-if="stepActive !== 0" @click="beforepro">上一步</el-button>
			<el-button @click="nextStep">{{ getnext }}</el-button>
		</div>
	</div>
</template>

<script>
import mock from './mock.json'
import dateformat from '@/utils/filter'
import citySingle from '@/components/citySingle.vue'

export default {
	name: 'CommodityAdd',
	components: { citySingle },
	data() {
		return {
			message: null,
			editID: '',
			data_parameter: [], //商品参数
			fileList: [], //上传附件
			data_category: '影像数据', //基础数据 产品数据
			selectbuttons: '',
			applicationList: [], //应用领域分类
			stepActive: 0, //步骤条选中
			satelliteOptions: [
				{
					//卫星分类
					value: 'HighViewSeries',
					label: '高景系列',
					children: [
						{
							value: '1',
							label: '高景1号'
						},
						{
							value: '2',
							label: '高景2号'
						},
						{
							value: '3',
							label: '高景3号'
						}
					]
				},
				{
					value: 'BeijingSeries',
					label: '北京系列',
					children: [
						{
							value: '4',
							label: '北京1号'
						},
						{
							value: '5',
							label: '北京2号'
						},
						{
							value: '6',
							label: '北京3号'
						}
					]
				},
				{
					value: 'zhuhaiSeries',
					label: '珠海系列',
					children: [
						{
							value: '7',
							label: '珠海1号'
						},
						{
							value: '8',
							label: '珠海2号'
						},
						{
							value: '9',
							label: '珠海3号'
						}
					]
				}
			],
			satelliteprops: {
				value: 'id',
				label: 'satelliteName',
				children: 'sonSatelliteCategoryListVO'
			},
			long_term_effective: false,
			goodsInfo_endDate: '', //截止日期
			deliveryDate: '', //交付时间  实时  天
			day: '', //交付天数
			satellite_classification: [], //卫星分类
			Myform: {
				basicImageInfo: {
					//	影像基础信息
					acceptingStation: '', //	接收站
					acquisitionTime: '', //	采集时间
					centerLatitude: '', //景中心纬度
					centerLongitude: '', //景中心经度
					// "createTime": "",//	创建时间
					// "dataSetInfoId": "", //	数据服务id ; data_set_info.id
					// "goodsId": "",//商品id：goods.id
					// "id": "",//	主键
					lowerLeftLatitude: '', //	左下纬度
					lowerLeftLongitude: '', //	左下经度
					lowerRightLatitude: '', //	右下纬度
					lowerRightLongitude: '', //右下经度
					pathwayNumber: '', //	轨道圈号
					productEndTime: '', //	产品结束时间
					productMiddleTime: '', //	产品中间行时间
					productStartTime: '', //	产品起始时间
					satellite: '', //卫星
					scene: '', //	景Path/Row
					sensor: '', //	传感器
					substar: '', //星下点Path/Row
					// "updateTime": "",//	修改时间
					upperLeftLatitude: '', //	左上纬度
					upperLeftLongitude: '', //左上经度
					upperRightLatitude: '', //	右上纬度
					upperRightLongitude: '' //	右上经度
				},
				goodsInfo: {
					//	商品基础信息
					chargingType: 0, //计费方式 1；按次收费；2.按周期收费
					// "checkTime": "", //审核时间
					// "checkUserId": 0, //	审核人id
					// "createTime": "", //创建时间
					// "createUserId": "", //创建人id：web_user_info.id
					dataDownloadUrl: '', //数据下载地址
					deliveryDate: 0, //交付时间 单位天，为空则为实时
					deliveryType: 2, //交付方式 1：线上交易；2.线下预约交易
					endDate: '', //截止日期，为空则长期有效
					goodsDescribe: '', //商品描述
					goodsCategory: 1, //商品类别：1.影像数据 2.数据产品、3.软件产品
					goodsDocUrl: '', //商品说明文档链接
					goodsName: '', //商品名称
					goodsPrice: 0, //商品价格
					goodsPriceType: 3, //商品价格类型：1：商品金额：2：面议；3：免费
					goodsThumbnail: '', //快视图
					goodsType: 1, //	商品类型：1：影像产品；2：产品数据 3.软件产品
					// "id": "",
					provinceId: '', //省id
					cityId: '', //	市id
					countyId: '', //	县id
					productPlateId: '', //应用领域：goods=2时有效；product_plate.id
					satelliteCategoryId: '' //卫星类别
					// "shelfStatus": 0,//	状态：0.待上架；1.上架；2.已下架；
					// "status": 0,//	状态：0.待审核；1.审核通过；2.审核不通过；
					// "supplierId": "",//关联的supplier_info.id 商家id
					// "updateTime": ""//修改时间
				},
				otherParam: {
					//	其他参数
					cameraLookingDownAngle: '', //	相机俯视角
					cameraView: '', //	相机前后视角
					// "createTime": "",//	创建时间
					// "dataSetInfoId": "", //	数据服务id ; data_set_info.id
					gainMode: '', //	增益模式
					// "goodsId": "",//商品id：goods.id
					// "id": "",//	主键
					integralLevel: '', //	积分级数
					integralTime: '', //	积分时间，单位为秒
					satelliteAzimuth: '', //	卫星方位角
					sunAzimuth: '', //太阳方位角
					satelliteHighAngle: '', //卫星高度角
					solarAltitudeAngle: '', //太阳高度角
					spAveragePitchingAngle: '', //	卫星平台（sp）平均俯仰角
					spAverageYawAngle: '', //卫星平台(sp)平均航偏角
					spRollingAngle: '' //卫星平台（sp）滚动角
					// "updateTime": ""//	修改时间
				},
				systemProductParam: {
					//	系统生产参数
					cloudCover: 0, //	云覆盖量
					// "createTime": "",//	创建时间
					// "dataSetInfoId": "", //	数据服务id ; data_set_info.id
					demDataSource: '', //DEM数据来源
					earthModel: '', //	地球模型
					ellipsoidModel: '', //	椭球模型
					floatingRate: 0, //	浮动比例
					// "goodsId": "",//	商品id：goods.id
					// "id": "",//	主键
					mapProjection: '', //	地图投影
					originalDataStripNumber: '', //	原始数据条带号
					productDataSize: 0, //	产品大小（单位MB）整数
					productDate: '', //	生产日期
					productDistinguishability: '', //	产品分辨率
					productFormat: '', //	产品格式
					productLevel: '', //	产品级别
					productSerialNumber: '', //	产品序列号
					productSpectralCoverage: '', //	产品谱段
					productType: '', //	产品类型
					productWidth: '', //	产品宽度（像素）
					projectionNumber: '', //	投影带号
					radiometricCorrectionMethod: '', //	辐射校正方法
					resamplingMethod: '', //	重采样方法
					sceneNumber: 0, //	连续景数
					sceneSerialNumber: '' //	景序列号
					// "updateTime": ""//	修改时间
				}
			},
			rules: {
				satellite_classification: [{ type: 'array', required: true, message: '卫星分类不能为空', trigger: 'blur' }],
				'goodsInfo.goodsName': [{ required: true, message: '请输入商品名称', trigger: 'blur' }]
			},
			// 回显省市区信息
			acceptCityInfo: []
		}
	},
	computed: {
		getnext() {
			return this.stepActive === 2 ? '完成，发布商品' : '下一步'
		},
		showProductData() {
			if (this.data_category !== '基础数据') {
				return true
			} else {
				return false
			}
		}
	},
	watch: {
		selectbuttons(newValue) {
			this.Myform.goodsInfo.productPlateId = newValue
		},
		'form.priceType'(newValue, oldValue) {
			this.form.currentPrice = ''
		},
		data_category(newValue, oldValue) {
			this.selectbuttons = ''
			if (newValue == '基础数据') {
				this.Myform.goodsInfo.goodsType = 1
			} else {
				this.Myform.goodsInfo.goodsType = 2
			}
		},
		long_term_effective(newValue, oldValue) {
			this.Myform.goodsInfo.endDate = ''
		},
		goodsInfo_endDate(newValue, oldValue) {
			this.Myform.goodsInfo.endDate = dateformat.timeFormat(newValue)
		},
		deliveryDate(newValue, oldValue) {
			if (newValue === '实时') {
				this.Myform.goodsInfo.deliveryDate = ''
			}
		},
		day(newValue) {
			if (newValue) {
				this.Myform.goodsInfo.deliveryDate = newValue
			}
		},
		satellite_classification(newValue) {
			console.log(newValue, 11)
			this.Myform.goodsInfo.satelliteCategoryId = newValue[1]
		}
	},
	created() {
		this.data_parameter = mock.data_parameter
		this.getProduct()
	},
	mounted() {
		// 商品编辑功能 内容展示
		if (this.$route.query.id) {
			this.editID = this.$route.query.id
			// 加载当前商品数据
			this.$http.get(this.$const.common.getShopGoodsDesc + this.editID).then((res) => {
				if (res.code === 200) {
					this.Myform = res.data

					this.acceptCityInfo = [this.Myform.goodsInfo.provinceName, this.Myform.goodsInfo.cityName, this.Myform.goodsInfo.countyName]
					if (this.Myform.goodsInfo.goodsType == 1) {
						this.data_category = '基础数据'
					} else {
						this.data_category = '产品数据'
						var that = this
						setTimeout(function () {
							that.selectbuttons = that.Myform.goodsInfo.productPlateId
						}, 100)
					}
					this.fileList = [
						{
							name: this.Myform.goodsInfo.goodsName + '说明文档',
							url: this.Myform.goodsInfo.goodsDocUrl
						}
					]
					this.goodsInfo_endDate = this.Myform.goodsInfo.endDate
					if (this.Myform.goodsInfo.endDate == '' || this.Myform.goodsInfo.endDate == null) {
						this.long_term_effective = true
					}
					if (this.Myform.goodsInfo.deliveryDate == '' || this.Myform.goodsInfo.deliveryDate == null) {
						this.deliveryDate = '实时'
					} else {
						this.deliveryDate = '天'
						this.day = this.Myform.goodsInfo.deliveryDate
					}
					this.satellite_classification[0] = this.Myform.goodsInfo.parentSatelliteCategoryId
					this.satellite_classification[1] = this.Myform.goodsInfo.satelliteCategoryId
					// this.long_term_effective = true;
					// this.isselect(this.Myform.goodsInfo.productPlateId)
				}
			})
		}
	},
	methods: {
		GreaterZero() {
			if (typeof this.Myform.goodsInfo.goodsPrice === 'string') {
				if (this.message) {
					this.message.close()
				}
				this.message = this.$message.warning('请输入数字')
				this.Myform.goodsInfo.goodsPrice = ''
				return
			}
			if (this.Myform.goodsInfo.goodsPrice <= 0) {
				if (this.message) {
					this.message.close()
				}
				this.message = this.$message.warning('请输入大于0的价格')
				this.Myform.goodsInfo.goodsPrice.goodsPrice = ''
			}
		},

		// 获取省市区信息
		getCityInfoFun(value) {
			console.log('获取省市区信息', value)
			this.Myform.goodsInfo.provinceId = value[0]
			this.Myform.goodsInfo.cityId = value[1]
			this.Myform.goodsInfo.countyId = value[2]
		},
		// 初始加载接口参数
		async getProduct() {
			try {
				// 应用领域数据
				let res = await this.$http.get(this.$const.MerchantWorkbench.GetlistProductSections)
				if (res.code === 200) {
					this.applicationList = res.data
				}
				// 卫星分类
				let res1 = await this.$http.get(this.$const.common.satelliteALL)
				if (res1.code === 200) {
					this.satelliteOptions = res1.data
				}
			} catch (e) {
				this.$message.error(e)
			}
		},
		// 上传快视图前
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/PNG' || file.type === 'image/JPG'
			const isLt2M = file.size / 1024 < 5000
			if (!isJPG) {
				this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 5M !')
			}
			return isJPG && isLt2M
		},
		// 上传快视图成功
		handleAvatarSuccess(res, file) {
			this.Myform.goodsInfo.goodsThumbnail = res.data
		},
		//上传前检测
		handlebeforeUpload(file, fileList) {
			const extension = file.name.split('.')[1] === 'docx' || file.name.split('.')[1] === 'pdf'
			const isLt2M = file.size / 1024 / 1024 < 20 //根据需求是否需要对上传文件大小进行限制
			if (!extension) {
				this.$message({
					message: '上传文件只能是 docx、pdf格式!',
					type: 'warning'
				})
			}
			if (!isLt2M) {
				this.$message({
					message: '上传文件大小不能超过 20MB!',
					type: 'warning'
				})
			}
			return extension && isLt2M
		},
		// 过滤重复
		filterRepetition(arr) {
			let arr1 = [] //存id
			let newArr = [] //存新数组
			for (let i in arr) {
				if (arr1.indexOf(arr[i].name) == -1) {
					arr1.push(arr[i].name)
					newArr.push(arr[i])
				}
			}
			return newArr
		},
		async uploadFile(file, filelist) {
			let flag = this.handlebeforeUpload(file, filelist)
			if (flag) {
				let arr = this.filterRepetition(filelist)
				if (arr.length !== filelist.length) {
					this.$notify.info({
						title: '提醒',
						message: '上传重复文件，已过滤重复文件',
						duration: 2000
					})
				}
				this.fileList = arr
				let formData = this.setFormData()
				try {
					let res = await this.$http.post(this.$const.common.fileUpload, formData)
					if (res.code === 200) {
						this.$message.success('上传成功')
						this.Myform.goodsInfo.goodsDocUrl = res.data
					} else {
						this.$message.warning(res.msg)
					}
				} catch (e) {
					this.$message.warning(e)
				}
			} else {
				let copy = [...this.fileList]
				this.fileList = copy
			}
		},
		//移除附件
		handleRemove(file, fileList) {
			this.fileList = fileList
			this.Myform.goodsInfo.goodsDocUrl = ''
		},
		handlePreview(file) {
			console.log(file)
		},
		handleExceed(files, fileList) {
			this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
		},
		beforeRemove(file, fileList) {
			return this.$confirm(`确定移除 ${file.name}？`)
		},
		// 应用领域选中
		selectapplication(button) {
			this.selectbuttons = button
		},
		// // 应用领域选中样式
		// isselect(button) {
		//   return button === this.selectbuttons
		// },

		setFormData() {
			if (this.fileList.length === 0) {
				this.$message.success('请上传文件')
				return
			}
			let formData = new FormData() //  用FormData存放上传文件
			this.fileList.forEach((file) => {
				formData.append(`file`, file.raw) // file.raw
			})

			return formData
		},
		// 上一步
		beforepro() {
			this.stepActive--
		},
		// 下一步 || 提交上架
		async nextStep() {
			console.log(this.Myform, '提交数据')
			if (++this.stepActive > 2) {
				if (this.editID != '' && this.Myform.goodsInfo.id) {
					// 修改商品
					try {
						let res = await this.$http.post(this.$const.MerchantWorkbench.product_update, this.Myform)
						if (res.code === 200) {
							this.$message.success('修改成功')
							var that = this
							// setTimeout(function () {
							that.$router.push({
								name: 'SellerCenter',
								query: {
									type: 'CommodityList'
								}
							})
							// }, 1000)
						}
					} catch (e) {
						this.$message.error(e)
					}
				} else {
					// 新增商品发布
					try {
						let res = await this.$http.post(this.$const.MerchantWorkbench.product_release, this.Myform)
						if (res.code === 200) {
							this.$message.success('发布成功')
							var that = this
							// setTimeout(function () {
							that.$router.push({
								name: 'SellerCenter',
								query: {
									type: 'CommodityList'
								}
							})
							// }, 1000)
						}
					} catch (e) {
						this.$message.error(e)
					}
				}

				this.stepActive = 0
			}
		},
		toBulkImport() {
			this.$router.push({
				name: 'SellerCenter',
				query: {
					type: 'BulkImport'
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.CommodityAdd {
	.type {
		height: 50px;
		line-height: 50px;
		font-size: 20px;
		font-weight: 600;
		color: #444;
	}

	.step_bar {
		display: flex;
		justify-content: space-between;
		width: 80%;
		margin: 0 auto;

		> .el-steps {
			flex: 1;
		}

		::v-deep .el-step__head.is-process {
			color: #3868e9;
			border-color: #3868e9;
		}

		::v-deep .el-step__title.is-process {
			color: #3868e9;
		}

		::v-deep .el-step__head.is-success {
			color: #3868e9;
			border-color: #3868e9;
		}

		::v-deep .el-step__title.is-success {
			color: #3868e9;
		}
	}

	.formBox {
		min-height: 400px;
		width: 950px;
		margin: 20px auto;

		.step0 {
			.keywordsdesc {
				font-size: 12px;
				margin: 0 0 5px 0;
				padding-left: 110px;
				color: #a5a5a5;
			}

			.imgList {
				margin: 10px 0;

				.el-upload__tip {
					margin-top: 0;
					line-height: normal;
				}
			}

			.form_item {
				min-height: 50px;
			}

			.inputWidth {
				width: 400px;
			}

			.el-form-item {
				margin-bottom: 0;
			}

			.btn {
				padding: 0px 15px;
				color: #666666;
				background: none;
				cursor: pointer;
				border: 1px solid rgba(204, 204, 204, 0.9);
				height: 36px;
				line-height: 36px;
			}

			.isclick {
				color: #3868e9;
				background: #3867e90a;
				border: 1px solid #3868e9;
				position: relative;
			}

			.isclick::after {
				content: '';
				// display: block;
				position: absolute;
				top: -1px;
				left: -1px;
				width: 10px;
				height: 10px;
				background-image: url('../../../assets/imgs/home/rightJiao.svg');
			}
		}

		.step1 {
			.table_infoItemLeft {
				display: flex;
				align-items: center;
				width: 50%;
				padding: 0 10px;
				height: 30px;
				line-height: 30px;
				background: #d1e4f0;
				text-align: right;
				justify-content: flex-end;
				color: #444;
			}

			.table_infoItemRight {
				display: flex;
				align-items: center;
				width: 50%;
				padding: 0 10px;
				background: #dfeaf0;
				height: 30px;
				line-height: 30px;
				color: #333;
			}

			.table_datetimeRight {
				display: flex;
				align-items: center;
				width: 50%;
				padding: 0 10px;
				background: #dfeaf0;
				height: 30px;
				line-height: 30px;
				color: #333;

				/deep/.el-input__inner {
					background: #dfeaf0;
					padding: 0;
					padding-left: 17px;
					border: none;
					height: 28px;
					line-height: 28px;
					font-size: 13px;
					cursor: pointer;
				}

				/deep/ .el-input__prefix {
					left: 0px;
				}
			}

			.table_infoItem {
				display: flex;
				align-items: center;
				width: 33.3%;
				font-size: 12px;
				margin-bottom: 5px;
			}

			.table_infoBox {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
			}

			.tableBox {
				//padding: 0 20px;
				margin-bottom: 10px;
			}

			.table_title {
				color: #aaa;
				padding-left: 40px;
				height: 30px;
				line-height: 30px;
				background-color: #e6f2ff;
			}

			.detailInfo_LitleTitle {
				margin: 0 20px 10px;
				border-left: 4px solid #2469f1;
				padding-left: 10px;
				color: #2469f1;
			}
		}

		.step2 {
			padding: 0 130px;
		}
	}

	.buttonBox {
		display: flex;
		justify-content: center;
	}
}
</style>